import { BaseController } from '../../base/controller';
import _ from 'lodash';

export class ActionTabsController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({ controllerService });
  }

  toggleTab() {
    const tabs = _.values(this.tabs);
    let nextIndex = tabs.indexOf(this.currentTab) + 1;
    if (nextIndex >= tabs.length) {
      nextIndex = 0;
    }
    this.handleOnChange(tabs[nextIndex]);
  }

  handleOnChange(tabId) {
    if (tabId === this.currentTab) {
      return;
    }

    // Send event to parent controller
    return this.onChange({
      $event: {
        tabId
      }
    });
  }
}
